import "@styles/main.scss"

// Temporary dependencies until migrated to other projects in shared theme

// Supports weights 300-800
import "@fontsource-variable/open-sans"
import "@fontsource/poppins/400.css"
import "@fontsource/poppins/500.css"
import "@fontsource/poppins/600.css"
import "@fontsource/poppins/700.css"

import { setGlobalTokens } from "@ehi/styles"

setGlobalTokens()

const normalizePath = (pathname) =>
    pathname === '/' ? pathname : pathname.replace(/\/$/, '');

const shouldForceReload = (pathname) =>
    normalizePath(pathname).startsWith('/about-ehealth/');

export const onClientEntry = () => {
    window.addEventListener('load', () => {
        setupRedirectScript();
    });
};

export const onPreRouteUpdate = ({ location, prevLocation }) => {
    if (prevLocation && shouldForceReload(location.pathname)) {
        window.location.href = `${window.location.origin}${location.pathname}${location.search || ''}${location.hash || ''}`;
    }
};

function setupRedirectScript() {
    // Listen to all clicks in the capture phase
    document.addEventListener(
        'click',
        (event) => {
            const target = event.target;
            if (!(target instanceof HTMLElement)) return;
            const anchor = target.closest('a');
            if (!anchor) return;

            const url = new URL(anchor.href, window.location.href);
            if (url.origin !== window.location.origin) return;

            if (shouldForceReload(url.pathname)) {
                event.preventDefault();
                event.stopPropagation();
                window.location.href = anchor.href;
            }
        },
        true
    );
}
